import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analyticsId = import.meta.env.VITE_GA4_ANALYTICS_ID

const analytics = analyticsId
  ? Analytics({
      app: 'auth',
      plugins: [
        googleAnalytics({
          measurementIds: [analyticsId],
        }),
      ],
    })
  : null

export function usePageTracking() {
  const location = useLocation()

  useEffect(() => {
    analytics?.page()
  }, [location.pathname, location.search])
}
